import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { GlobalStyle } from './asset/styles/GlobalStyle';
import { AudioTrack } from './components/pages/AudioTrack';
import { Ebook } from './components/pages/Ebook';
import { Main } from './components/pages/Main';
import { Menu } from './components/pages/Menu';
import { Resources } from './components/pages/Resources';
import { setTab, setZoom } from './store/CommonSlice';

function App() {
  const dispatch = useDispatch();
  
  useEffect(() => {
    const FixRatio = () => {
      const wrap = document.querySelector("#wrap");
      const root = document.querySelector("#root");

      const standardWidth = 1920;
      const standardHeight = 1080;
  
      // 원하는 해상도로 width, height 고정
      root.style.width = `${standardWidth}px`;
      root.style.height = `${standardHeight}px`;
  
      let width = wrap.clientWidth;
      let height = width * (standardHeight / standardWidth);
      
      // style.zoom을 이용하여, 화면을 크기를 조정
      root.style.zoom = height / standardHeight;

      if (height > wrap.clientHeight) {
        height = wrap.clientHeight;
        width = height * (standardWidth / standardHeight);
        
        // style.zoom을 이용하여, 화면을 크기를 조정
        root.style.zoom = width / standardWidth; 
      }

      // 몹바일 터치 미세 조정값
      dispatch(setTab((window.innerHeight - height) / 2));

      dispatch(setZoom(root.style.zoom));
    }

    window.onresize = FixRatio; // 화면의 사이즈가 변할 때마다 호출
    FixRatio(); // 맨 처음 실행 될 때도 호출
  });
  
  return (
    <>
      <GlobalStyle />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Main />}></Route>
          <Route path="/menu/:book" element={<Menu />}></Route>
          <Route path="/ebook" element={<Ebook />}></Route>
          <Route path="/audio" element={<AudioTrack />}></Route>
          <Route path="/resources" element={<Resources />}></Route>
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
